import { render, staticRenderFns } from "./DocumentUploadProvider.vue?vue&type=template&id=34889e07&scoped=true&"
import script from "./DocumentUploadProvider.vue?vue&type=script&lang=ts&"
export * from "./DocumentUploadProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34889e07",
  null
  
)

export default component.exports